export default __webpack_public_path__ + "static/media/page-title-badge-dark.4ffacfef.svg";